import { FieldsErrors } from '@alfa-retail-react/components';
import { ValidationError } from '@alfa-retail-react/components/form-hook/ValidationError';

import { Exception } from 'app/api/exception/Exception';

/**
 * Исключение используется в случае ошибок валидации.
 * HTTP статус код для ошибок валидации: 422 Unprocessable entity.
 */
export class ValidationException extends Exception {
    static readonly NAME = 'ValidationException';

    constructor(id: string, type: string, message: string, errors: any) {
        super(id, type, message);
        this.errors = this.mapErrors(errors);
        this.name = ValidationException.NAME;
    }

    mapErrors(errors: ValidationError[]): FieldsErrors<any> {
        return errors.reduce((acc, { context, message }) => {
            acc.set(context, { message });
            return acc;
        }, new Map());
    }

    /**
     * Список ошибок валидации.
     */
    errors: FieldsErrors<any>;
}
